export enum FileHosts {
  server = 'server',
  google = 'google',
}

export enum FileTag {
  LOGO = 'LOGO',
  PHOTO = 'PHOTO',
  AVATAR = 'AVATAR',
  OFFER = 'OFFER',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  PERSONAL_DATA_CONSENT = 'PERSONAL_DATA_CONSENT',
  MARKETING_CONSENT = 'MARKETING_CONSENT',
}

export type FileEntityType = 'CLIENT' | 'SERVICE' | 'ADDRESS' | 'USER'

export interface IUploadFilesRequest {
  entityType: FileEntityType
  entityId: number
  tag: FileTag
  sortPosition?: number
  files: File[]
}

export interface IFileResponse {
  id: number
  entityType: FileEntityType
  entityId: number
  tag: FileTag
  url: string
  mimetype: string
  sizeBytes: number | null
  sortPosition: number
  createdAt: string
}

export interface IReorderFilesRequest {
  items: { id: number; sortPosition: number }[]
}

export interface IFile extends File {
  created: Date
  fullPath: string
  host: FileHosts
  id: number
  jsId?: number
  serviceId?: number
  addressId?: number
  appId?: number
  clientId?: number
  mimetype: string
  sortPosition: number
  tag: FileTag
  loaded?: boolean
}
